import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getReselectDirection} from '../../../../store/data/preferences/preferencesSelectors';
import {refetchCellsAsyncAction} from '../../../../store/panels/cells/cellsPanelActions';
import {makeGetCellsPanel} from '../../../../store/panels/cells/cellsPanelSelectors';
import {CellsPanelId} from '../../../../store/panels/panelStateBase';
import {CellsContent} from './cellsContent';

/*
 * Props.
 */

export interface CellsContentContainerPublicProps {
  panelId: CellsPanelId;
}

/*
 * Selectors.
 */

/** Find all the cells pages for the current panel. */
function makeGetPages() {
  return createSelector([makeGetCellsPanel()], (panel) => panel.pages);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CellsContentContainerPublicProps>()(() => ({
  pages: makeGetPages(),
  reselectDirection: getReselectDirection,
}));

const mapDispatchToProps = makeMapDispatchToProps<CellsContentContainerPublicProps>()(({panelId}) => ({
  onReconnect: () => refetchCellsAsyncAction(panelId),
}));

export const CellsContentContainer = connect(mapStateToProps, mapDispatchToProps)(CellsContent);
